export interface IProductSubCategory {
  name: string;
  description: string;
  imgSrc?: string;
}

export interface IProductCategory {
  name: string;
  description: string;
  imgSrc: string;
  subCategories: IProductSubCategory[];
}

export const productCategoryInitialState: IProductCategory[] = [
  {
    name: "Neck Chains",
    description:
      "Timeless, carefully curated neckpieces crafted to layer seamlessly or make a standalone statement.",
    imgSrc: "",
    subCategories: [
      {
        name: "Gold Plated",
        description:
          "Lustrous gold-finished chains engineered with tarnish-resistant coatings for lasting radiance.",
      },
      {
        name: "Silver Plated",
        description:
          "Sleek, cool-toned links offering a crisp modern polish suitable for daily wear.",
      },
      {
        name: "Pearl",
        description:
          "Elegant strands and hybrid link designs accented with luminous, organic freshwater Pearl.",
      },
    ],
  },
  {
    name: "Ear Rings",
    description:
      "Eye-catching studs, drops, and hoops thoughtfully designed to frame the face with subtle brilliance.",
    imgSrc: "",
    subCategories: [
      {
        name: "Gold Plated",
        description:
          "Warm, gold-toned hoops and huggies that deliver everyday glamour without weighing you down.",
      },
      {
        name: "Silver Plated",
        description:
          "Versatile silver silhouettes featuring hypoallergenic posts crafted for comfort and daily shine.",
      },
      {
        name: "Pearl",
        description:
          "Classic and baroque pearl drops that effortlessly transition from casual daytime to evening wear.",
      },
      {
        name: "Precious Stones",
        description:
          "Vibrant faceted crystals and gem accents that catch the light from every possible angle.",
      },
    ],
  },
  {
    name: "Bracelets",
    description:
      "Refined wristwear ranging from delicate stacking accents to bold, structured cuff statements.",
    imgSrc: "",
    subCategories: [
      {
        name: "Gold Plated",
        description:
          "Gleaming gold-toned chain links and solid bangles designed for effortless wrist stacking.",
      },
      {
        name: "Silver Plated",
        description:
          "Minimalist silver bands and adjustable links offering an understated, tailored finish.",
      },
      {
        name: "Pearl",
        description:
          "Graceful pearl strands and beaded cuffs adding an air of timeless sophistication.",
      },
      {
        name: "Leather",
        description:
          "Textured leather bands paired with polished metallic hardware for a modern edge.",
      },
    ],
  },
  {
    name: "Wrist Watches",
    description:
      "Precision timepieces combining functional accuracy with sophisticated, jewelry-inspired aesthetics.",
    imgSrc: "",
    subCategories: [
      {
        name: "Golden Strapped",
        description:
          "Striking gold-tone mesh and link bracelets that serve as elegant statement accessories.",
      },
      {
        name: "Silver Strapped",
        description:
          "Brushed and polished stainless steel strap, offering a crisp, professional aesthetic.",
      },
      {
        name: "Leather Strapped",
        description:
          "Supple genuine leather bands delivering comfortable all-day wear and classic luxury.",
      },
    ],
  },
  {
    name: "Rings",
    description:
      "Artfully molded bands and statement pieces made to mix, match, and stack on any finger.",
    imgSrc: "",
    subCategories: [
      {
        name: "Gold Plated",
        description:
          "Warm-toned signets, textured bands, and delicate stackers finished in rich gold plate.",
      },
      {
        name: "Silver Plated",
        description:
          "Contemporary silver bands crafted with high-polish surfaces for a clean, sharp look.",
      },
      {
        name: "Black Metal",
        description:
          "Bold, matte and gunmetal-finished bands designed for an edgy, unconventional style.",
      },
    ],
  },
  {
    name: "Bags",
    description:
      "Structured silhouettes and everyday carryalls blending premium textures with practical utility.",
    imgSrc: "",
    subCategories: [
      {
        name: "Shoulder",
        description:
          "Curved crescents and sleek underarm bags made for seamless hands-free convenience.",
      },
      {
        name: "Tote",
        description:
          "Spacious, durable daily carryalls with ample room to hold all your work and lifestyle essentials.",
      },
      {
        name: "Clutch",
        description:
          "Compact handheld evening bags and zip pouches designed to carry your after-dark essentials.",
      },
    ],
  },
];
